/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Status_ReadyInputs */

const en_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata ready`)
};

const ar_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البيانات الوصفية جاهزة`)
};

const bn_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মেটাডেটা প্রস্তুত`)
};

const de_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten bereit`)
};

const es_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos listos`)
};

const fr_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métadonnées prêtes`)
};

const pt_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados prontos`)
};

const zh_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据已就绪`)
};

const tr_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta veriler hazır`)
};

const ru_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные готовы`)
};

const pl_image_inspector_status_ready = /** @type {(inputs: Image_Inspector_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadane gotowe`)
};

/**
* | output |
* | --- |
* | "Metadata ready" |
*
* @param {Image_Inspector_Status_ReadyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_status_ready = /** @type {((inputs?: Image_Inspector_Status_ReadyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Status_ReadyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_status_ready(inputs)
	if (locale === "bn") return bn_image_inspector_status_ready(inputs)
	if (locale === "de") return de_image_inspector_status_ready(inputs)
	if (locale === "es") return es_image_inspector_status_ready(inputs)
	if (locale === "fr") return fr_image_inspector_status_ready(inputs)
	if (locale === "pt") return pt_image_inspector_status_ready(inputs)
	if (locale === "zh") return zh_image_inspector_status_ready(inputs)
	if (locale === "tr") return tr_image_inspector_status_ready(inputs)
	if (locale === "ru") return ru_image_inspector_status_ready(inputs)
	if (locale === "pl") return pl_image_inspector_status_ready(inputs)
	return en_image_inspector_status_ready(inputs)
});